import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  height: ${({ height }) => height || "auto"};
  padding: ${({ padding }) => padding || "0 6%"};
  background-color: ${({ bg }) => bg || "none"};
  position: ${({ position }) => position || "static"};
  top: ${({ top }) => top || "auto"};
  bottom: ${({ bottom }) => bottom || "auto"};
  left: ${({ left }) => left || "auto"};
  right: ${({ right }) => right || "auto"};
  z-index: ${({ zIndex }) => zIndex || "0"};
  transform: ${({ transform }) => transform || "none"};

  @media (max-width: 768px) {
    height: ${({ heightMobile, height }) => heightMobile || height};
    padding: ${({ padding, paddingMobile }) => paddingMobile || padding || "0 6%"};
  }
`;

export default Container;
